const routes = [
    {
        path: "/course-registration-rule",
        component: () => import("../page/Index"),
        meta: {
            isAuthenticated: true,
            permission:"mergesection_index"
        },
        component_full_path: 'courseRegistrationRule/page/Index'
    }
];

export default routes;
